/**
 * Env config
 */
const ENV_CONFIG = process.env;

/*
 * Gainsight configuration
 */
const giansightConfig = {
  key: ENV_CONFIG.VUE_APP_GAINSIGHT_PRODUCT_KEY,
};

export default Object.freeze(giansightConfig);
